import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CategoryBreakdownDto } from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsByCategoryParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
}

export const fetchSavingsByCategory = createAsyncThunk<
    CategoryBreakdownDto[],
    FetchSavingsByCategoryParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsByCategory',
    async ({ dateFrom, dateTo, propertyIds, categoryIds }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const response = await extra.api.post<{
                items: CategoryBreakdownDto[];
            }>('/v1/reports/savings-insights/by-category', {
                dateFrom,
                dateTo,
                ...(propertyIds?.length
                    ? {
                          propertyIds,
                      }
                    : {}),
                ...(categoryIds?.length
                    ? {
                          categoryIds,
                      }
                    : {}),
            });
            return response.data.items ?? [];
        } catch {
            return rejectWithValue('error');
        }
    },
);
